"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HidePriceEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const CheckBox_1 = require("../../../CheckBox");
const HidePriceEditor = (props) => {
    const { field } = props;
    return (react_1.default.createElement(CheckBox_1.CheckBox, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/AdminPayment:hidePrice', defaultMessage: 'Hide price' }), error: field.error, checked: field.input, onChange: field.onEvent, hidden: field.hidden }));
};
exports.HidePriceEditor = HidePriceEditor;
//# sourceMappingURL=hidePrice.js.map